import { PaymentType } from "./payment-type.enum";

    /**
     * @description
     *  Modelo de un pago de revendedor.
     *
     * @see gigot-backend/Models/Users/ResellerStatement.cs
     */

export class ResellerPayment {

    public applicationUserId: string;
	public id: number;
	public paidAmount: number;
	public paymentDate: Date;
	public paymentSource: string;
	public paymentType: PaymentType;
	public resellerTransactionId: number;

	/**
     * @description
     *	Construye un pago con una semántica vacía. Nótese que no es lo mismo
	 *	que construir un pago con valores por defecto. Las reglas generales de
	 *	construcción son:
     *
     *      - Campos 'array' se definen como [].
     *      - Campos 'boolean' se definen como 'false'.
     *      - Campos 'Date' se definen como 'undefined'.
     *      - Campos 'enum' se definen como 'undefined'.
     *      - Campos 'number' se definen como 'undefined'.
     *      - Campos 'string' se definen como '' (cadena vacía).
     *      - Campos 'object' se definen llamando a su propio método #empty().
     *      - Campos de la superclase se definen al igual que campos 'object'.
     *      - Campos genéricos se definen como 'undefined'.
	 *		- Campos recursivos se definen como 'undefined'.
     *
     * @returns
     *	Un pago vacío.
     */
	public static empty(): ResellerPayment {
		const resellerPayment: ResellerPayment = new ResellerPayment();
		resellerPayment.applicationUserId = "";
		resellerPayment.id = undefined;
		resellerPayment.paidAmount = undefined;
		resellerPayment.paymentDate = undefined;
		resellerPayment.paymentSource = "";
		resellerPayment.paymentType = undefined;
		resellerPayment.resellerTransactionId = undefined;
		return resellerPayment;
	}

	/**
     * @description
     *  Método de reificación de un modelo compatible anémico. Esto permite
     *  ejecutar lógica de negocios sobre el modelo generado, siendo que el
     *  valor de sus propiedades se mantiene.
     *
     * @param anemicResellerPayment
     *  El modelo anémico a reificar.
     *
     * @returns
     *  Devuelve un modelo de esta clase, cuyas propiedades fueron copiadas en
     *  profundidad desde el modelo anémico.
     */
	public static from(anemicResellerPayment: ResellerPayment): ResellerPayment {
		if (!anemicResellerPayment) return undefined;
        const resellerPayment: ResellerPayment = ResellerPayment.empty();
		resellerPayment.applicationUserId = anemicResellerPayment.applicationUserId;
		resellerPayment.id = anemicResellerPayment.id;
		resellerPayment.paidAmount = anemicResellerPayment.paidAmount;
		resellerPayment.paymentDate = new Date(anemicResellerPayment.paymentDate);
		resellerPayment.paymentSource = anemicResellerPayment.paymentSource;
		resellerPayment.paymentType = anemicResellerPayment.paymentType;
		resellerPayment.resellerTransactionId = anemicResellerPayment.resellerTransactionId;
		return resellerPayment;
	}
}
